import { z } from "zod";
/**
 * THE COACH'S NOTES (pedagogy review, 2026-09-11; decision 5 and step 3):
 * what the coach carries about one learner between engagements, so that it
 * is the same coach every time — one that has watched every engagement and
 * remembers what it saw.
 *
 * Written by the Coach role from the immutable record after each finished
 * engagement, validated on ingress (Law 4), and stored by code. The notes
 * are a DERIVATION of the record, never a source of truth about it: nothing
 * in them can change a reading, and the record can always regenerate them.
 * Everything is words — no numeral, no rank — so the notes can be read back
 * to the learner in full without breaking the no-rank rule.
 */
const Line = z.string().min(1).max(400).refine((text) => !/\d/.test(text), { message: "the coach's notes carry no numerals" });
export const CoachNotesSchema = z.strictObject({
    /** How this learner tends to work, as seen in their own words and moves — their unique approach, not the two profile tokens. */
    approach: Line,
    /** What the record shows them doing well, as behaviours. */
    strengths: z.array(Line).max(4),
    /** What to work on next, as behaviours, in priority order. */
    working_on: z.array(Line).max(3),
    /** Specific ways to practise that the coach has already suggested — so it builds on them rather than repeating them. */
    strategies_given: z.array(Line).max(6),
    /** The arc so far, engagement by engagement, in one paragraph. */
    arc: z.string().min(1).max(1400).refine((text) => !/\d/.test(text), { message: "the coach's notes carry no numerals" }),
});
//# sourceMappingURL=coach-notes.js.map